export const ROLES = {
  USER: 'user',
  WORKER: 'worker',
  ADMIN: 'admin',
  VOLUNTEER: 'volunteer'
}; 